module.exports = __webpack_public_path__ + "static/media/icon-switch-qrcode.8f551ed0.svg";